// We need helpers to include all controllers in Vite without listing them explicitly
// https://github.com/ElMassimo/stimulus-vite-helpers?tab=readme-ov-file#usage-

import { application } from './application'
import { registerControllers } from 'stimulus-vite-helpers'

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)
